import styles from 'components/chartView/tooltip.scss';

/**
 * Template for the highcharts tooltip used in chartView. This is not in JSX
 * because it used by the HighCharts API.
 * @see  config/chartConfig
 * @param  {string} options.year   Tooltip title
 * @param  {array} options.series  Array of strings to show in tooltip list
 * @return {string}                HTML for tooltip
 */
export default function tooltip({ year, series }) {
  return `
    <div class="${styles.tooltip}">
      <h3 class="${styles.title}">${year}</h3>
      <ul class="${styles.list}">
        <li class="${styles.item}">
          ${series.join(`</li><li class="${styles.item}">`)}
        </li>
      </ul>
    </div>
  `;
}



// WEBPACK FOOTER //
// ./app/components/chartView/tooltip.js